import { Breakpoints } from '@/lib/breakpoints';
import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    grid: {
      width: '100%',
      boxSizing: 'border-box',
      columnCount: 2,
      columnGap: Spacings.s16,
      [Breakpoints.SM]: { columnCount: 3 },
      [Breakpoints.MD]: { columnCount: 4 },
      [Breakpoints.LG]: { columnCount: 5 },
    },
    card: {
      marginBottom: Spacings.s16,
      breakInside: 'avoid',
    },
  },
  { name: 'masonry-skeleton' },
);

export default useStyles;
